module.exports = __webpack_public_path__ + "lato-bold-italic-9c7e4e9eb485b4a121c760e61bc3707c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-bold-italic/lato-bold-italic.woff
// module id = 1061
// module chunks = 0